<template>

    <div>

        <el-dialog title="导入实名名单" :visible.sync="showImport" center :before-close="handleClose">
            <el-form>

                <el-form-item label="从Excel文件导入名单">
                    <br/>
                    <el-upload
                            class="upload-demo"
                            action="''"
                            multiple
                            :limit="1"
                            :http-request="importFile"
                            :before-upload="beforeImport"
                    >
                        <el-button size="small" type="primary">导入文件</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传 xlsx/xls/csv 文件，且不超过500kb</div>
                        <div slot="tip">导入的Excel文件确保第一列为 姓名 第二列为 手机号</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label="学校名单:">
                    <el-input type="textarea" @change="formatImportText" v-model="importText" placeholder='请将内容复制输入到此' size="medium" rows="10"
                              autocomplete="off">
                    </el-input>
                    <p>
                        <b>温馨提示：</b><br/>
                        1.实名认证，输入格式为：“真实姓名+手机号" 用逗号分隔。（例如: 张三,13888888888）<br>
                        2.一次最多导入 100 个账号<br>
                    </p>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleImportText" :disabled="importText == ''">批量导入</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量实名&绑定" :visible="isShow" :before-close="handleClose" width="50%">

            <el-alert
                    title="温馨提示: 对不存在的姓名账号已做过滤处理"
                    type="success">
            </el-alert>

            <el-table v-loading="loading" :data="details" style="width: 100%" height="400">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="真实姓名" prop="real_name"></el-table-column>
                <el-table-column label="手机号" prop="mobile">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.mobile" size="mini" placeholder="输入要设置的手机号"/>
                    </template>
                </el-table-column>
                <el-table-column align="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="removeRow(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="save" :loading="submiting">确 定</el-button>
            </div>
        </el-dialog>
    </div>


</template>

<script>
    import AccountService from "~/services/CustomerAccounts";
    import CustomerService from "~/services/customer";
    import {Regexp} from "~/config/params";
    import Excel from 'xlsx'


    const MAX_ACCOUNT_TOTAL = 100;

    const make_cols = refstr => Array(Excel.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:Excel.utils.encode_col(i), key:i}));

    export default {
        name: "BranchRealAuth",
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            accounts: {
                type: Array,
                default: [],
                required: true
            },
            display: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showImport: false,
                importText: '',

                isShow: false,
                details: [],
                loading: false,
                submiting: false,

                sheetData: [], //Excel 表格数据
                sheetColumns: [], // Excel 表格中的列
            }
        },
        created() {
            //this.isShow = this.display;
            this.showImport = this.display;
            // if (this.accounts.length > 0 && this.details.length == 0) {
            //     this.getDetails();
            // }
        },
        watch: {
            sheetData: function (value, original) {
                if (value.length > 0) {
                    this.joinImportText();
                }
            },
        },
        methods: {

            /**
             * 导入文件
             * @param param
             */
            importFile(param) {

                let file = param.file;

                let rf = new FileReader();
                rf.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;

                    const wb = Excel.read(bstr, {type:'binary'});
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = Excel.utils.sheet_to_json(ws, {header:1});
                    /* Update state */
                    const cols = make_cols(ws['!ref']);

                    this.sheetData = data;
                    this.sheetColumns = cols;
                };

                rf.readAsBinaryString(file);
            },

            beforeImport(file) {
                let index = file.name.lastIndexOf(".");
                let ext = file.name.substr(index + 1);
                let allowExt = ['xlsx', 'xls', 'csv'];
                if (allowExt.indexOf(ext) < 0) {
                    this.$message.error("只支持上传 xlsx/xls/csv 等格式文件");
                    return false;
                }

                const isLt2M = file.size / 1024 < 500;
                if (!isLt2M) {
                    this.$message.error('导入文件大小不能超过 500 KB !');
                    return false;
                }

                return true;
            },


            formatImportText(text) {
                if (text == '') {
                    return '';
                }

                // 替换制表符
                text = text.replace(/\t/g, ",");
                text = text.replace(/\s\r/g, "");
                text = text.replace(/ /ig, "");

                // 替换中文逗号
                text = text.replace(/，/ig, ",");
                // 不同的中文逗号
                //text = text.replace("，", ",");

                this.importText = text;
            },

            joinImportText() {

                if (this.sheetData.length == 0) {
                    return;
                }

                let importText = '';
                this.sheetData.forEach((value, index) => {

                    let text = '';
                    if (value[0] && value[0] != '') {
                        let name = value[0];
                        text = text + name.replace(/\s\r\n\t/g, '');
                    }

                    if (value[1] && value[1] != '') {
                        let mobile = value[1].toString();
                        text = text + ',' + mobile.replace(/\s\r\n\t/g, '');
                    }

                    if (value[0] == '姓名' || value[1] == '手机') {
                        importText += '';
                    } else {
                        importText += text + '\n';
                    }
                })

                if (this.importText == '') {
                    this.importText = importText;
                } else {
                    this.importText += '\n' + importText;
                }
            },

            // 处理导入
            handleImportText() {

                let context = this.importText;

                if (context == '') {
                    return;
                }

                let accounts = context.split("\n");
                if (accounts.length < 1) {
                    this.$message.error('导入的数据格式不正确，请求修正后再重新导入');
                    return;
                }

                let data = [];

                let hasError = false;


                let allNames = [];

                accounts.forEach((val, key) => {
                    // 切割姓名手机号
                    let account = val.split(",");
                    // 直接过滤名字为空的记录
                    if (!account[0] || account == '') {
                        return;
                    }

                    if (!account[1] || account[1] == '') {
                        this.$message.error(account[0] + ' 的手机号不能为空');
                        hasError = true;
                        return;
                    }

                    // 验证手机号
                    if (account[1] && !Regexp.mobile.test(account[1])) {
                        this.$message.error(account[0] + ' 手机号 ' + account[1] + ' 填写有误');
                        hasError = true;
                        return;
                    }

                    let username = account[0];
                    allNames.push(account[0]);

                    data.push({
                        user_id: '',
                        username: username,
                        real_name: account[0],
                        mobile: account[1] ? account[1] : '',
                        customer_id: this.customerId,
                        identity: "1",
                        password: ''
                    });
                })

                if (data.length > MAX_ACCOUNT_TOTAL) {
                    this.$message.error('一次最多支持导入'+ MAX_ACCOUNT_TOTAL +'个账号');
                    return;
                }

                if (hasError) {
                    return;
                }

                if (data.length > 0) {
                    this.details = data;
                }

                if (allNames.length > 0) {
                    this.getPreview({
                        customer_id : this.customerId,
                        real_names: allNames
                    })
                }

                this.showImport = false;
                this.isShow = true;
            },

            getPreview(params) {
                this.loading = true;
                AccountService.getPreview(params).then(res => {
                    if (res.code == 0 && res.data != null) {

                        let serverData = {};
                        res.data.forEach((val, key) => {
                            serverData[val.real_name] = val;
                        });

                        // 过滤不存在 realNames 中的记录
                        if (this.details.length > 0) {

                            let results = []; // 过滤结果
                            this.details.forEach((val, key) => {
                                if (serverData[val.real_name] && serverData[val.real_name].user_id) {
                                    val.user_id = serverData[val.real_name].user_id;
                                    results.push(val);
                                }
                            });

                            this.details = results;
                        }
                    } else {
                        this.details = [];
                    }

                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                })
            },

            getDetails() {
                this.loading = true;
                AccountService.getDetails(this.accounts).then(res => {
                    if (res.code == 0) {
                        let accounts = [];
                        if (res.data.length > 0) {
                            // 过滤掉已经绑定过的数据
                            for (var key in res.data) {
                                if (res.data[key].mobile == '') {
                                    accounts.push(res.data[key]);
                                }
                            }
                        }
                        this.details = accounts;
                    }
                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                    this.loading = false;
                })
            },

            close(status = false) {
                this.isShow = false;
                this.accounts = [];
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            close(status = false) {
                this.isShow = false;
                this.submiting = false;
                this.details = [];
                this.$emit("callback", status);
            },

            removeRow(row) {
                this.$confirm("确定要移除改条记录？", "温馨提示", {type: "warning"}).then(ok => {
                    this.details.splice(this.details.indexOf(row), 1);
                }).catch(cancel => {
                    return false;
                });
            },

            save() {

                this.submiting = true;

                let accounts = [];
                if (this.details.length > 0) {
                    for (var key in this.details) {
                        if (this.details[key].mobile == '') {
                            this.$message.error("手机号不允许为空");
                            this.submiting = false;
                            return false;
                        }
                        accounts.push({
                            user_id: this.details[key].user_id,
                            mobile: this.details[key].mobile
                        });
                    }
                } else {
                    this.$message.error("没有符合条件的数据");
                    this.close();
                    return false;
                }

                AccountService.batchRealAuth(accounts).then(res => {
                    this.submiting = false;
                    if (res.code == 0) {
                        this.$message.success("批量实名&绑定成功!");
                        this.close(true);
                    }
                }).catch(err => {
                    console.error(err);
                    this.submiting = false;
                })

            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/customer/dialog/BranchRealAuth.vue